import { TemplateElement, html, defineElement } from '@webtides/element-js';
import { unsafeHTML } from 'lit-html/directives/unsafe-html.js';

export default class HighlightText extends TemplateElement {
    constructor() {
        super({ shadowRender: false });
    }

    properties() {
        return {
            text: '',
            search: '',
            highlightClass: 'underline',
            searchOr: 'false',
        };
    }

    template() {
        let searchRegex = this.search.toString().trim();
        if (this.searchOr) {
            searchRegex = searchRegex.replace(' ', '|');
        }

        const litText = this.text.replace(
            new RegExp(`(${searchRegex})`, 'gi'),
            `<span class="${this.highlightClass}">$1</span>`
        );

        return html` ${unsafeHTML(litText)} `;
    }
}

defineElement('highlight-text', HighlightText);
